/* eslint-disable import/no-named-as-default */
// We expose the non-wrapped components for testing
// and importing the Redux-wrapped component in routes gives an error
import React from 'react';
import {
  Route,
  IndexRoute,
} from 'react-router';

import AppContainer from 'views/AppContainer';
import NotFoundPage from 'views/NotFoundPage';

import DashboardContainer from 'views/dashboard/DashboardContainer';
import LibraryPage from 'views/library/LibraryPage';

import PassengerAddPage from 'views/library/passengers/PassengerAddPage';
import PassengerEditPage from 'views/library/passengers/PassengerEditPage';

import DriverAddPage from 'views/library/drivers/DriverAddPage';
import DriverEditPage from 'views/library/drivers/DriverEditPage';

import LoginPage from 'views/auth/ConcedoLoginPage';
import ConcedoCallbackPage from 'views/auth/ConcedoCallbackPage';

import SimulationPage from 'views/autosim/SimulationPage';

import ReportContainer from 'views/reports/ReportContainer';
import TokenContainer from 'views/token_management/TokenContainer';
import CentralDashboardPage from 'views/dashboard/CentralDashboardPage';
import ResourceGeneratorContainer from 'views/resource_generator/ResourceGeneratorContainer';

export default function routes(store) {
  const requireAuth = (nextState, replace, callback) => {
    const state = store.getState();
    const user = state.app.user || {};
    if (!user.concedoToken) {
      replace('/login');
    }
    callback();
  };

  return (
    <Route path="/">
      <IndexRoute component={LoginPage} />
      <Route path="login" component={LoginPage} />
      <Route path="concedoCB" component={ConcedoCallbackPage} />
      <Route path="app" component={AppContainer} onEnter={requireAuth}>
        <IndexRoute component={DashboardContainer} />
        <Route path="/cohorts/:cohortID" component={DashboardContainer} />
        <Route path="/library">
          <IndexRoute component={LibraryPage} />
          <Route path="/passengers/new" component={PassengerAddPage} />
          <Route path="/passengers/:cohortPassengerID/edit" component={PassengerEditPage} />
          <Route path="/drivers/new" component={DriverAddPage} />
          <Route path="/drivers/:cohortDriverID/edit" component={DriverEditPage} />
        </Route>
        <Route path="/auto" component={SimulationPage} />
        <Route path="/report" component={ReportContainer} />
        <Route path="/token" component={TokenContainer} />
        <Route path="/dashboard" component={CentralDashboardPage} />
        <Route path="/generate-resources" component={ResourceGeneratorContainer} />
      </Route>
      <Route path="*" component={NotFoundPage} />
    </Route>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/routes.jsx
 **/